export function roundToDec(floatedNumber, precision = 2){
  let multiplier = Math.pow(10, precision);
  return Math.round(floatedNumber * multiplier) / multiplier;
}
